<template>
  <div>
    <VueJs></VueJs>
    <VueCli></VueCli>
    <Ecosystem></Ecosystem>
    <Quasar></Quasar>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Quasar from "../components/dev/Quasar";
import VueCli from "../components/dev/VueCli";
import VueJs from "../components/dev/VueJs";
import Ecosystem from "../components/dev/Ecosystem";

@Component({
  components: {
    Quasar,
    VueCli,
    VueJs,
    Ecosystem
  }
})
export default class Dev extends Vue {}
</script>

<style lang="sass" scoped></style>
